import Backbone from 'backbone';

/* eslint import/prefer-default-export: 0 */
export function postCSV({ url, data, success, error, complete }) {
  Backbone.$.ajax({
    url,
    data,
    type: 'POST',
    contentType: 'text/csv',
    headers: { Accept: 'text/csv' }, // Can't use 'accepts' property because */* gets appended
    dataType: 'csv',
    converters: { 'text csv': result => result },
  })
  .done(success)
  .fail(error)
  .always(complete);
}



// WEBPACK FOOTER //
// ./utils/xhr.js